import template from './report_page.html';

class ReportPageViewModel {
	constructor(page) {
		this.page = page;

		this.title = ko.observable('Placeholder');

		this.report_page_id = ko.observable();
		this.report_page_definition = ko.observable();
		this.latest_report_info; //Todo this replaces this.report_result_definition = ko.observable();
		this.report_definition = ko.observable();
		//Report parameters
		this.params_fields = ko.observableArray([]);
		this.params_inputs = ko.observableArray([]);
		

		this.chart_name = ko.observable('');
		this.chart_title = ko.observable('');
		//Chart display
		this.chart_display_count = ko.observable(0);

		this.hide_report = ko.observable(false);
		this.hide_report_caption = ko.observable('Hide Data');

		this.schema_name = ko.observable('reports_data');
		this.table_name = ko.observable();
		this.data_source = ko.observable();
		
		this.report_status_message = ko.observable('');

		this.report_id = this.page.bindings.report_id;
		this.report_created_date = ko.observable();
		this.record_total = ko.observable();

		this.table_data = ko.observableArray([]);
		this.report_data;

		this.is_error = ko.observable(false);
		ko.bindingHandlers.alert_status = {
			update: (element, valueAccessor) => {
				let value = ko.unwrap(valueAccessor());
				if (value != 'warning' && value != 'danger') {
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-danger', false);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-info', true);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-warning', false);
				}
				else if (value === 'warning') {
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-danger', false);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-info', false);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-warning', true);
				}
				else if (value === 'danger') {
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-danger', true);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-info', false);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-warning', false);
				}
			}
		};
	}

	async load() {
		// Fetch report page definition based on the report page id
		let request_obj = {
			schema: 'reports',
			table: 'report_page',
			filter: [
				{ field: 'report_page_id', operand: '=', value: this.report_page_id()}
			]
		};
		
		let response = await Grape.fetches.getJSON('/api/record', request_obj);
		if (response.status === 'OK') {
			this.title(response.records[0].name);
			this.report_page_definition(response.records[0]);

			await this.get_latest_report_info();
			await this.get_report_definition();
			this.build_param_definition();
			
			await this.get_report_results();
			await this.get_echart_info();
		}
		else
			throw new Error('Error!');
	}

	async get_latest_report_info(){
		let request_obj = {
			schema: 'reports',
			table: 'v_latest_reports',
			filter: [
				{ field: 'report_definition_id', operand: '=', value: this.report_page_definition().report_definition_id}
			],
			limit: 1
		};
		let response = await Grape.fetches.getJSON('/api/record', request_obj);
		if (response.status !== 'OK') {
			throw new Error('Error!');
			return;
		}
		this.latest_report_info = response.records[0];
	}

	async get_report_definition(){
		let request_obj = {
			schema: 'reports',
			table: 'report_definition',
			filter_join: 'AND',
			filter: [
				{ field: 'report_definition_id', operand: '=', value: this.latest_report_info.report_definition_id},
				{ field: 'version', operand: '=', value: this.latest_report_info.version}
			],
			limit: 1
		};
		let response = await Grape.fetches.getJSON('/api/record', request_obj);
		if (response.status !== 'OK') {
			console.error('Report definition not found:', this.latest_report_info.report_definition_id);
			return;
		}
		this.report_definition(response.records[0]);
	}

	build_param_definition(){
		let ui_fields = this.report_definition().default_function_criteria.query_ui_fields;
		let last_ui_field_values = this.latest_report_info.report_function_criteria;

		ui_fields.forEach((f) => {
			if (last_ui_field_values?.[f.name]){
				if (f.type == 'json'){
					f.default_value = JSON.stringify(last_ui_field_values[f.name]);;
				}
				else if (f.type = 'list'){
					if (f.list_options != ''){
						f.items = f.list_options.split(',');
						f.default_value = last_ui_field_values[f.name];
					}
					f.$input = last_ui_field_values[f.name];
				}else
					f.default_value = last_ui_field_values[f.name];
			}
		});

		this.params_fields(ui_fields);

	}

	async get_report_results()
	{
		this.data_source({
			schema: 'reports_data',
			table: this.latest_report_info.result_table
		});
	}



	async get_echart_info(){
		if (this.report_page_definition().chart_id == null)
			return;

		let request_obj = {
			schema: 'echarts',
			table: 'v_chart_info',
			filter: [
				{field: 'chart_id', operator: '=', value: this.report_page_definition().chart_id}
			]
		};
		let result = await Grape.fetches.getJSON('/api/record', request_obj);
		if (result.status === 'ERROR'){
			Grape.alerts.alert({
				type: 'error',
				message: result.message,
				title: 'Error'
			});
		}

		if(result.records.length == 0){
			Grape.alerts.alert({
				type: 'warning',
				message: 'Unable to find chart data.',
				title: 'Warning'
			});
		}

		let record = result.records[0];
		this.chart_name(record.name);			
	}

	btn_show_hide_report_click(){
		if (this.hide_report()){
			this.hide_report(false);
			this.hide_report_caption('Hide Data');
		}else{
			this.hide_report(true);
			this.hide_report_caption('Show Data');
		}
	}

	async refreshReportResults() {
		let req_obj = {
				'report_definition_id': this.report_definition().report_definition_id,
				'version': this.report_definition().version,
				'report_type': this.report_definition().report_type,
				'function_schema': '',
				'function_name': '',
				'active':true,
				'default_function_criteria': '',
				'report_function_criteria': ''
		}

		if (this.report_definition().report_type == 'query' && this.params_inputs()){
			let params = {};
			for (let [name, input] of Object.entries(this.params_inputs())){
				for (const field of this.params_fields()){
					if (field.name == name){
						if (field.type == 'json'){
							if (typeof (input()) === "object")
								params[name] = input();
							else
								params[name] = JSON.parse(input());
						}else if (field.type == 'list'){
							if (typeof (input()) === "object")
								params[name] = input().value;
							else
								params[name] = input();
						}else
							params[name] = input();
					}
				}
			}
			req_obj.default_function_criteria = params;
			req_obj.report_function_criteria = params;
		}

		let data = await Grape.fetches.postJSON('/api/report/create', req_obj);
		if (data.status === 'OK')
		{
			if (!data.report)
			{
				Grape.alerts.alert({
					type: 'warning',
					message: 'User does not have the correct permission to run this report',
					title: 'Report Creation Error'
				});
			}else{
				this.latest_report_info.report_id = data.report.report_id;
				this.get_report_generation_status();
			}
		}
	}

	
	async get_report_generation_status()
	{
		let data = await Grape.fetches.getJSON('/api/report', { 'report_id': this.latest_report_info.report_id});
		if (data) {
			if (data.status === 'ERROR' || ['Error', 'Completed', 'New', 'Running', 'Starting', 'Pending'].indexOf(data.report_status) < 0) {
				this.is_error('warning');
				this.report_status_message('Error - no report data to display! Please ensure the query, table, or function has data!');
				return null;
			}

			if (data.report_status === 'Error') {
				this.is_error('danger');
				this.report_status_message(data.report_status);
				let response = await Grape.alerts.confirm({
					type: 'error',
					title: 'Error!',
					message: 'An unknown error occurred. Please ensure the query is valid or contact IT support.'
				});
			}
			else if (data.report_status === 'Completed') {
				this.is_error(false);
				this.report_status_message('');

				this.latest_report_info.date_inserted = data.metadata.date_inserted;
				this.latest_report_info.report_function_criteria = data.metadata.report_function_criteria;
				this.latest_report_info.result_table = data.metadata.result_table;

				this.data_source({
					schema: 'reports_data',
					table: this.latest_report_info.result_table
				});
				this.chart_display_count(this.chart_display_count() + 1);
			}
			else {
				if (data.report_status === 'Running')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'NewTask')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'Pending')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'Starting')
					this.report_status_message(data.report_status);

				// Try again in 2000 milliseconds
				this.timer = setTimeout(
					() => {
						this.get_report_generation_status();
					},
					2000
				);
			}
		}
	}








	
	async build_function_criteria(){
		let rep_def = this.report_result_definition();
	}


}

class ReportPagePage {
	constructor(bindings, element) {
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ReportPageViewModel(this);
		this.name = 'ReportPagePage';
	}

	async init() {
		this.viewModel.report_page_id(this.bindings.report_page_id);
		this.viewModel.load();
	}

	updateData() {
	}

	teardown() {
		clearTimeout(this.viewModel.timer);
	}
}

export default {
	route: '[/]reports/report_page/:report_page_id',
	page_class: ReportPagePage,
	template: template
};
